import { render, staticRenderFns } from "./ChannelFourCarousel.vue?vue&type=template&id=e7bafbe4&scoped=true"
import script from "./ChannelFourCarousel.vue?vue&type=script&lang=js"
export * from "./ChannelFourCarousel.vue?vue&type=script&lang=js"
import style0 from "./ChannelFourCarousel.vue?vue&type=style&index=0&id=e7bafbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bafbe4",
  null
  
)

export default component.exports